import { useDroppable } from "@dnd-kit/core";
import { useChatDragAvailable } from "./chatDragContext";
import { useHoverActivation } from "./useHoverActivation";

/**
 * A drop zone that opens something (the Chat tab, the collapsed pane) when a
 * row drag rests on it. Dropping on it does nothing. Inert outside a task chat.
 * Returns the ref callback for the element.
 */
export function useSpringLoadedDropZone({
    id,
    onActivate,
}: {
    id: string;
    onActivate: () => void;
}) {
    const isAvailable = useChatDragAvailable();
    const { setNodeRef, isOver } = useDroppable({
        id,
        disabled: !isAvailable,
    });
    useHoverActivation({ isOver, onActivate });
    return setNodeRef;
}
